import { Button } from '@/components/atoms';
import { YieldBearingAssetInterface } from '@/interfaces';
import { FC, useState } from 'react';
import { IoSparklesSharp } from 'react-icons/io5';
import YieldBearingAssetCompositionRecommendationTray from './YieldBearingAssetCompositionRecommendationTray';
interface QuestionAnswer {
  question: string;
  rating: number;
}
interface YieldBearingAssetCompositionRecommendationButtonProps {
  asset: YieldBearingAssetInterface;
  onOptimize: (assessment: QuestionAnswer[], userCommentary?: string) => void;
  className?: string;
  fullWidth?: boolean;
  loading?: boolean;
}
const AiIcon = IoSparklesSharp as React.ComponentType<any>;
const YieldBearingAssetCompositionRecommendationButton: FC<
  YieldBearingAssetCompositionRecommendationButtonProps
> = ({ asset, onOptimize, className, fullWidth = false, loading = false }) => {
  const [isTrayOpen, setIsTrayOpen] = useState(false);
  const handleOpenTray = () => {
    setIsTrayOpen(true);
  };
  const handleCloseTray = () => {
    setIsTrayOpen(false);
  };
  const handleOptimizeFromTray = (
    qaList: QuestionAnswer[],
    userCommentary?: string,
  ) => {
    setIsTrayOpen(false);
    onOptimize(qaList, userCommentary);
  };
  return (
    <>
      <Button
        icon={`ai`}
        intent={`ai`}
        onClick={handleOpenTray}
        flexHeight
        fullWidth={fullWidth}
        className={`${className}`}
        loading={loading}
        iconStyles={{ intent: 'ai', size: 'md' }}
      >
        Recommend
      </Button>
      <YieldBearingAssetCompositionRecommendationTray
        isOpen={isTrayOpen}
        onClose={handleCloseTray}
        asset={asset}
        onOptimize={handleOptimizeFromTray}
      />
    </>
  );
};
export default YieldBearingAssetCompositionRecommendationButton;
